module.exports = __webpack_public_path__ + "media/images/icons/total-class-color-icon-94a9f3d2ecbe5a6154d96e646e9f5788.svg";